import { Outlet, useLocation } from 'react-router-dom'
import { Toasts } from '../features/toasts/toasts.tsx'
import { Menu } from '../features/rightmenu/menu.tsx'
import { useIsMobile } from '../shared/lib/hooks.ts'
import { cn } from '../shared/lib/utils.ts'
import { Navbar } from '../features/navbar/navbar.tsx'
import { MainContainer } from '../shared/ui/card/card.tsx'
import { urls } from '../shared/urls.ts'

const NAVBAR_EXCEPTIONS = ['/payment', urls.paymentSuccess]

export function Layout(props: {
  withMenu: boolean
  withNavbar: boolean
  fullWidth?: boolean
  scroll?: boolean
  white?: boolean
  customContainer?: boolean
  mainContainer?: boolean
}) {
  const location = useLocation()
  const isMobile = useIsMobile()
  const isException = NAVBAR_EXCEPTIONS.some((exception) =>
    location.pathname.includes(exception),
  )
  const showDesktopMenu =
    !isMobile && ((props.withNavbar && !isException) || props.withMenu)
  const showMobileNavbar = props.withNavbar && !isException && isMobile
  const contentMaxClass = 'max-w-1000 2xl:max-w-1300'
  // Main uses floating cards on bglight — skip the white page card.
  const enableMainContainer =
    !props.customContainer &&
    props.withNavbar &&
    !isMobile &&
    location.pathname !== urls.main

  return (
    <div
      className={cn(
        'w-full [scrollbar-width:thin]',
        props.white ? 'bg-white xl:bg-bglight' : 'bg-light xl:bg-bglight',
      )}
    >
      {showMobileNavbar ? <Navbar /> : null}
      {showDesktopMenu ? (
        <div className="flex min-h-dvh justify-center gap-24 px-24 2xl:gap-40 2xl:px-48">
          <Menu />
          <div className={cn('relative min-w-0 flex-1', contentMaxClass)}>
            <MainContainer enable={enableMainContainer}>
              <Outlet />
            </MainContainer>
          </div>
        </div>
      ) : (
        <div className="relative flex min-h-dvh">
          <MainContainer enable={false}>
            <Outlet />
          </MainContainer>
        </div>
      )}
      <Toasts />
    </div>
  )
}
